export enum TypeOfSupport {
    ISSUE_REPORT = 1,
    NEED_ACCESS = 2,
    HAVE_QUERY = 3,
    HAVE_SUGGESTION = 4,
  }
